import { render, staticRenderFns } from "./UserSettingsLayout.vue?vue&type=template&id=0fec5d02&scoped=true&lang=pug&"
import script from "./UserSettingsLayout.vue?vue&type=script&lang=js&"
export * from "./UserSettingsLayout.vue?vue&type=script&lang=js&"
import style0 from "./UserSettingsLayout.vue?vue&type=style&index=0&id=0fec5d02&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fec5d02",
  null
  
)

export default component.exports